import interact from "interactjs";

import { generateArr } from "@/utils/array";

const draggable = interact(".drag-drop");
const dropzone = interact(".dropzone");

const dragMoveListener = (event) => {

    const { target } = event;

    // keep the dragged position in the data-x/data-y attributes
    const x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx;
    const y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;

    // translate the element
    target.style.transform = 'translate(' + x + 'px, ' + y + 'px)';

    // update the posiion attributes
    target.setAttribute('data-x', x);
    target.setAttribute('data-y', y);
};

const calculateArea = (targetDom, moveDom) => {

    const rect = targetDom.getBoundingClientRect();

    const tx1 = parseInt(rect.left);
    const ty1 = parseInt(rect.top);

    const tx2 = tx1 + parseInt(rect.width);
    const ty2 = ty1 + parseInt(rect.height);

    const { left, top, width, height } = moveDom.getBoundingClientRect();

    const mx1 = parseInt(left);
    const my1 = parseInt(top);

    const mx2 = mx1 + parseInt(width);
    const my2 = my1 + parseInt(height);

    const w = Math.min(tx2, mx2) - Math.max(tx1, mx1);
    const h = Math.min(ty2, my2)- Math.max(ty1, my1);
    
    const stackArea = (w > 0? w : 0) * (h > 0? h : 0);
    const moveDomArea = width * height;

    return {
        stackArea,
        moveDomArea
    };
};

const isOver = (targetDom, moveDom, ratio=0.75) => {

    const { stackArea, moveDomArea } = calculateArea(targetDom, moveDom);
 
    return stackArea/moveDomArea > ratio;
};

const checkWhereIsTarget = (moveDom) => {

    const arr = generateArr(9);

    const resultArr = arr.map(i => {

        const boxId = `board-${i+1}`;

        const targetDom = document.querySelector(`#${boxId}`);

        const { stackArea } = calculateArea(targetDom, moveDom);

        return {
            boxId,
            stackArea
        };
    });

    const max = Math.max.apply(null, resultArr.map(el => el.stackArea));

    return resultArr.find(el => el.stackArea === max).boxId;
};

const isOverHandler = (target) => {

    const boxId = checkWhereIsTarget(target);

    const box = document.querySelector(`#${boxId}`);

    const { left, top, width, height, x, y } = box.getBoundingClientRect();

    const topElements = document.elementsFromPoint(x, y);

    const topImageElements = topElements.filter(element => element.nodeName === "IMG");

    if (topImageElements.length > 0) {

        const topImageElement = topImageElements[0];

        topElementImageHandler(topImageElement, target);

        return;
    }

    const topDivElements = topElements.filter(element => element.id.indexOf("image") >= 0);

    if (boxId === "board-1" && topDivElements.length > 0) {

        const topElement = topDivElements[0];

        board1Handler(topElement, target);

        return;
    }

    const image = target.firstElementChild;

    target.style.position = "fixed";
    target.style.left = `${left}px`;
    target.style.top = `${top}px`;
    target.style.width = `${width}px`;
    target.style.height = `${height}px`;
    target.style.border = "none";

    const idNumber = parseInt(boxId.split("-")[1]);

    let imageHeight = height - 3;
    let imageWidth = width - 3;

    if ([3, 6, 9].includes(idNumber)) {
        imageWidth += 3;
    }

    if ([7, 8, 9].includes(idNumber)) {
        imageHeight += 3;
    }

    image.style.left = `${left}px`;
    image.style.top = `${top}px`;
    image.style.width = `${imageWidth}px`;
    image.style.height = `${imageHeight}px`;
    image.style.border = "none";

    switch(boxId) {
        case "board-1":

            image.style.borderRadius = "10px 0 0 0";

            break;
        case "board-3":

            image.style.borderRadius = "0 10px 0 0";

            break;
        case "board-9":

            image.style.borderRadius = "0 0 10px 0";

            break;
        case "board-7":

            image.style.borderRadius = "0 0 0 10px";

            break;
        default:
            image.style.borderRadius = "0px";
    }
    
    image.style.boxShadow = "0 0 0 0";
};

const board1Handler = (topElement, target) => {

    const topElementId = topElement.id;
    const targetId = target.id;

    topElement.id = targetId;
    target.id = topElementId;

    const topElementImage = topElement.firstElementChild;
    const targetImage = target.firstElementChild;

    topElementImage.id = targetId;
    targetImage.id = topElementId;

    const topSrc = topElementImage.src;
    const targetSrc = targetImage.src;

    topElementImage.src = targetSrc;
    targetImage.src = topSrc;
}

const topElementImageHandler = (topElement, target) => {

    const targetImage = target.firstElementChild;

    const tmpSrc = topElement.src;
    
    topElement.src = targetImage.src;
    targetImage.src = tmpSrc;

    const topId = topElement.id;
    
    topElement.id = targetImage.id;
    targetImage.id = topId;
    target.id = topId;
};

const evaluateResult = () => {

    const numArr = generateArr(9);

    return numArr.map(num => {

        const id = num + 1;

        const board = document.querySelector(`#board-${id}`);

        const { x, y } = board.getBoundingClientRect();

        const topElements = document.elementsFromPoint(x, y);

        return topElements.filter(el => {

            if (el.id.indexOf("image") < 0) {
                return false;
            }

            return parseInt(el.id.split("-")[1]) === id;
        }).length > 0;
    }).every(el => el);
};

const interactMixin = {
    methods: {
        init() {

            draggable.draggable({
                inertia: true,
                autoScroll: true,
                modifiers: [
                    interact.modifiers.restrictRect({
                        restriction: document.querySelector('#puzzle-table'),
                        endOnly: true,
                    })
                ],
                listeners: { 
                    move: dragMoveListener,
                    end: (event) => {
               
                        const { target } = event;
            
                        const puzzleTableElement = document.getElementById("puzzle-table");
            
                        let x = 0;
                        let y = 0;
            
                        if (isOver(puzzleTableElement, target, 0)) {
                            isOverHandler(target);
                        }  
            
                        // translate the element
                        target.style.transform = `translate(${x}px,${y}px)`;
            
                        // update the posiion attributes
                        target.setAttribute('data-x', x);
                        target.setAttribute('data-y', y);

                        setTimeout(() => {

                            if (evaluateResult()) {

                                this.$bus.$emit(this.$constants.EVENT.END_OPERATION, {
                                    type: this.$constants.ENUM.END_OPERATION.SUCCESS
                                });
                            }
                        }, 500);
                    }
                }
            });
            
            dropzone.dropzone({
                accept: ".drag-drop",
                overlap: 0.50
            });
        }
    }
};

export default interactMixin;

